import { Reducer } from 'redux';

import { TResort, ISetResorts, ISetResort } from '../actions';
import { Resort } from '../entities';

export type IResortsState = Resort[];
export const defaulIResortsState = [];

export const resortsReducer: Reducer<IResortsState> = (
  state: IResortsState = defaulIResortsState,
  action: ISetResorts
): IResortsState => {
  switch (action.type) {
    case TResort.SET_RESORTS:
      return action.payload;
  }
  return state;
};

export type IResortState = Resort;
export const defaultResortState = {};

export const resortReducer: Reducer<IResortState> = (
  state: IResortState = defaultResortState,
  action: ISetResort,
): IResortState => {
  switch (action.type) {
    case TResort.SET_RESORT:
      localStorage.setItem('resortId', action.payload.id);
      return action.payload;
  }
  return state;
};
